import { formatHeatmapMetric } from './metricFormat';

export const markersUtil = () => {
  /**
   * @param {Object} size
   * @returns {Object} Bubble Size Setings { x, y, scale }
   */
  const getSize = (size, ranges) => {
    const sizeSettings = {
      20: { x: 35, y: 35, scale: 0.8 },
      40: { x: 33, y: 30, scale: 0.875 },
      60: { x: 30, y: 25, scale: 0.95 },
      80: { x: 28, y: 18, scale: 1.025 },
      100: { x: 25, y: 10, scale: 1.1 },
      default: { x: 25, y: 10, scale: 1.1 }
    };

    if (!size) return undefined
    if (size.default) return sizeSettings['default']

    const rangesValues = ranges || [0, 25, 50, 75, 100]
    const [val1, val2, val3, val4] = rangesValues

    const percentage = Number(size.percent || 0)

    if (percentage <= val1) return sizeSettings['20']
    if (percentage <= val2) return sizeSettings['40']
    if (percentage <= val3) return sizeSettings['60']
    if (percentage <= val4) return sizeSettings['80']
    if (percentage >= val4) return sizeSettings['100']

    return sizeSettings['0']
  }

  const DEFAULT_COLORS = ['#549FF5', '#1DBE1D', '#FDD71A', '#ED1C24']

  const getColor = (color, ranges, colorHexes) => {

    const palette = (Array.isArray(colorHexes) && colorHexes.length === 4)
      ? colorHexes
      : DEFAULT_COLORS
    const fallback = '#888888'

    if (!color) return undefined
    if (color.default) return fallback

    const rangesValues = ranges || [0, 35, 100]
    const [val1, val2, val3] = rangesValues

    const percentage = Number(color.percent || 0)

    if (percentage <= val1) return palette[0]
    if (percentage <= val2) return palette[1]
    if (percentage <= val3) return palette[2]
    if (percentage >= val3) return palette[3]

    return palette[0]
  }

  /**
   *
   * @param {*} shadow
   * @returns
   */
  const getShadow = (shadow, ranges) => {
    if (!shadow) return undefined

    const percentage = Number(shadow.percent || 0)

    const shadowSettings = {
      0: { rx: 0, ry: 0 },
      25: { rx: 10, ry: 5 },
      50: { rx: 20, ry: 7 },
      75: { rx: 27, ry: 10 },
      100: { rx: 35, ry: 15 }
    }

    const rangesValues = ranges || [0, 35, 65, 100]
    const [val1, val2, val3] = rangesValues

    if (percentage === 0) return shadowSettings['0']
    if (percentage <= val1) return shadowSettings['25']
    if (percentage <= val2) return shadowSettings['50']
    if (percentage <= val3) return shadowSettings['75']
    if (percentage >= val3) return shadowSettings['100']

    return shadowSettings['0']
  }

  /**
   *
   * @param {*} size
   * @param {*} number
   * @returns
   */
  const getLabel = (size, number, ranges) => {
    if (!size) return undefined;

    const numberText = number;

    const labelSettings = {
      20: { x: 37, y: 37, text: numberText },
      40: { x: 36, y: 35, text: numberText },
      60: { x: 35, y: 33, text: numberText },
      80: { x: 35, y: 30, text: numberText },
      100: { x: 34, y: 25, text: numberText },
      default: { x: 34, y: 25, text: numberText }
    };

    if (size.default) return labelSettings['default'];

    const rangesValues = ranges || [0, 25, 50, 75, 100];
    const [val1, val2, val3, val4] = rangesValues;

    const percentage = Number(size.percent || 0);

    if (percentage <= val1) return labelSettings['20'];
    if (percentage <= val2) return labelSettings['40'];
    if (percentage <= val3) return labelSettings['60'];
    if (percentage <= val4) return labelSettings['80'];
    if (percentage >= val4) return labelSettings['100'];

    return labelSettings['0'];
  };

  /**
   *
   * @param {*} metrics
   * @returns
   */
  const getMarkerConfig = (metrics, currentMapDetails, fields = []) => {
    // console.log('METRICS => ', metrics)

    const metricsByRef = {
      number: undefined,
      size: undefined,
      sizeRanges: undefined,
      color: undefined,
      colorRanges: undefined,
      colorHexes: undefined,
      shadow: undefined,
      shadowRanges: undefined
    }

    metrics.forEach((metric) => {
      metric.ref === 'number'
        ? (metricsByRef[metric.ref] = metric.total)
        : (metricsByRef[metric.ref] = metric)
    })

    const currentMapMetrics = currentMapDetails?.metrics
    currentMapMetrics &&
    currentMapMetrics?.length &&
    currentMapMetrics.forEach((metric) => {
      if (!!metric.ranges && metric.ref !== 'number') {
        metricsByRef[`${metric.ref}Ranges`] = [...metric.ranges]
      }
      if (metric.ref === 'color' && Array.isArray(metric.color_hexes)) {
        metricsByRef.colorHexes = [...metric.color_hexes]
      }
    })


    const [isNum, isSize, isColor] = [
      metricsByRef?.number !== undefined,
      metricsByRef?.size !== undefined,
      metricsByRef?.color !== undefined
    ]

    if ((!isSize && isNum) || (!isSize && isColor)) {
      metricsByRef.size = { default: true }
    }

    if ((!isColor && isSize) || (!isColor && !isSize && isNum)) {
      metricsByRef.color = { default: true }
    }

    const result = {
      size: getSize(metricsByRef?.size, metricsByRef?.sizeRanges),
      color: getColor( metricsByRef?.color, metricsByRef?.colorRanges, metricsByRef?.colorHexes),
      shadow: getShadow(metricsByRef?.shadow, metricsByRef?.shadowRanges),
      label: !isNum
        ? undefined
        : getLabel(
            metricsByRef?.size,
            formatHeatmapMetric(
              metrics.find(metric => metric.ref === 'number'),
              currentMapDetails?.metrics?.find(metric => metric.ref === 'number'),
              fields, true
            ),
            metricsByRef?.sizeRanges
          )
    }

    // console.log('result', result)
    return result
  }

  /**
   *
   * @param {*} size
   * @returns
   */
  const sizeMarkerIconItem = (size) => {
    if ((!size?.x && size?.x !== 0) || (!size?.y && size?.y !== 0) || (!size?.scale && size?.scale !== 0)) return undefined

    const item = [
      `<g transform="translate(${size.x} ${size.y}) scale(${size.scale})">`,
      '<path  class="st1" d="M48.8168,25.1286C48.8168 38.8184 24.4084 61.0897 24.4084 61.0897C24.4084 61.0897 0 38.8184 0 25.1286C0 11.4387 10.9286 0.339844 24.4084 0.339844C37.8882 0.339844 48.8168 11.4387 48.8168 25.1286Z"/>',
      '</g>'
    ].join('')

    return item
  }

  /**
   *
   * @param {string} color
   * @returns
   */
  const colorMarkerIconItem = (color) => {

    const item = `.st1 {fill: %23${
      color ? color?.slice(1) : '#888888'.slice(1)
    }}`

    return item
  }

  /**
   *
   * @param {*} shadow
   * @returns
   */
  const shadowMarkerIconItem = (shadow) => {
    if ((!shadow?.rx && shadow?.rx !== 0) || (!shadow?.ry && shadow?.ry !== 0)){
      return undefined
    }

    const item = [
      '<g transform="translate(57 79) scale(1)">',
      `<ellipse class="st0" cx="0" cy="0" rx="${shadow.rx}" ry="${shadow.ry}"/>`,
      '</g>'
    ].join('')

    return item
  }

  /**
   *
   * @param {*} type
   * @param {*} data
   * @returns
   */
  const getMarkerIconItem = (type, data) => {
    const typeToFunction = {
      size: sizeMarkerIconItem,
      color: colorMarkerIconItem,
      shadow: shadowMarkerIconItem
    }

    const func = typeToFunction[type] || undefined

    return !!func ? func(data) : undefined
  }

  /**
   *
   * @param {*} param0
   * @returns
   */
  const generateMarkerIcon = ({ size, color, shadow }) => {
    // console.log('color => ', color)
    return [
      'data:image/svg+xml;utf-8,',
      '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="1900px" height="1900px" xml:space="preserve">',
      '<style type="text/css">',
      `.st0 {fill: %23888888}`,
      // `.st1 {fill: %23${color?.slice(1)}}`,
      getMarkerIconItem('color', color),
      '.first {fill: %23ffffff;font: 11px verdana, sans-serif;}',
      '</style>',
      '<g transform="translate(0 0) scale(20)">',
      // Shadow
      // '<g transform="translate(57 79) scale(1)">',
      // `<ellipse class="st0" cx="0" cy="0" rx="${shadow.rx}" ry="${shadow.ry}"/>`,
      // '</g>',
      getMarkerIconItem('shadow', shadow),
      // Size
      // `<g transform="translate(${size.x} ${size.y}) scale(${size.scale})">`,
      // '<path  class="st1" d="M48.8168,25.1286C48.8168 38.8184 24.4084 61.0897 24.4084 61.0897C24.4084 61.0897 0 38.8184 0 25.1286C0 11.4387 10.9286 0.339844 24.4084 0.339844C37.8882 0.339844 48.8168 11.4387 48.8168 25.1286Z"/>',
      // '</g>',
      getMarkerIconItem('size', size),
      // '<g transform="translate(23 30)">',
      // '<text class="first">19,234</text>',
      // '</g>',
      '</g>',
      '</svg>'
    ].join('')
  }

  /**
   *
   * @param {*} param0
   * @returns
   */
  const markerIcon = ({ size, color, shadow, label }) => ({
    url: generateMarkerIcon({ size, color, shadow }),
    size: new window.google.maps.Size(67, 67),
    scaledSize: new window.google.maps.Size(65, 65),
    anchor: new window.google.maps.Point(29, 34),
    labelOrigin: label && new window.google.maps.Point(label.x, label.y)
  })

  const statusMarkerIcon = ({ status, missingFieldCount = 0, zoom }) => {
    const isEmpty = status === 'empty'
    const numericZoom = Number(zoom)
    const renderedSize = isEmpty && Number.isFinite(numericZoom)
      ? Math.max(30, Math.min(58, 18 + (numericZoom * 6)))
      : 64
    const svg = isEmpty
      ? [
          '<svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54">',
          '<circle cx="27" cy="27" r="18" fill="white" stroke="#D32F2F" stroke-width="4"/>',
          '<path d="M20 20L34 34M34 20L20 34" stroke="#D32F2F" stroke-width="5" stroke-linecap="round"/>',
          '</svg>'
        ].join('')
      : [
          '<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64">',
          '<path d="M31 57S13 40 13 25C13 14.5 21 7 31 7s18 7.5 18 18c0 15-18 32-18 32Z" fill="#F9A825" stroke="white" stroke-width="3"/>',
          '<text x="31" y="34" text-anchor="middle" font-family="Arial,sans-serif" font-size="25" font-weight="700" fill="#3D3D3D">?</text>',
          '<rect x="42" y="2" width="20" height="18" rx="9" fill="#D32F2F" stroke="white" stroke-width="2"/>',
          `<text x="52" y="15" text-anchor="middle" font-family="Arial,sans-serif" font-size="11" font-weight="700" fill="white">${missingFieldCount}</text>`,
          '</svg>'
        ].join('')

    return {
      url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`,
      size: new window.google.maps.Size(64, 64),
      scaledSize: new window.google.maps.Size(renderedSize, renderedSize),
      anchor: new window.google.maps.Point(
        renderedSize / 2,
        isEmpty ? renderedSize / 2 : renderedSize * (58 / 64)
      )
    }
  }

  /**
   *
   * @param {*} data
   * @param {*} contentStyle
   * @returns
   */
  const escapeHtml = (value) => String(value ?? '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;')

  const calculationLabels = {
    avg: 'Average',
    count: 'Count',
    max: 'Maximum',
    min: 'Minimum',
    sum: 'Sum'
  }

  const getHeatmapInfoWindowDiv = (idx, pin, currentMapDetails, fields = []) => {
    if (Array.isArray(pin)) {
      return getHeatmapInfoWindowDiv(idx, { metrics: pin }, currentMapDetails, fields)
    }

    const metrics = Array.isArray(pin?.metrics) ? pin.metrics : []
    const configuredMetrics = Array.isArray(currentMapDetails?.metrics)
      ? currentMapDetails.metrics
      : []
    const count = Number(pin?.count || 1)
    const contributingCount = Number(
      pin?.contributing_location_count ?? pin?.contributingLocationCount ?? count
    )
    const missingFieldCount = Number(
      pin?.missing_field_count ?? pin?.missingFieldCount ?? 0
    )
    const locationName = pin?.location_name ?? pin?.locationName
    const groupName = pin?.field
    const title = count === 1
      ? locationName || groupName || 'Location'
      : groupName || `${count.toLocaleString()} locations`
    const context = count > 1
      ? `${contributingCount.toLocaleString()} locations contributing data`
      : contributingCount > 0
        ? '1 location contributing data'
        : 'No heatmap data populated'
    const warning = missingFieldCount > 0
      ? `<div style="margin:8px 10px 0;padding:7px 9px;border-radius:5px;background:#FFF3E0;color:#9A4F00;font:600 12px Lato,Arial,sans-serif;">${missingFieldCount} field${missingFieldCount === 1 ? '' : 's'} without data</div>`
      : ''

    const rows = metrics.map(metric => {
      const configuredMetric = configuredMetrics.find(item => item.ref === metric.ref) || {}
      const hasData = metric.has_data ?? metric.hasData ?? true
      const label = escapeHtml(metric.label || configuredMetric.label || metric.ref || 'Metric')
      const calc = metric.calc || configuredMetric.calc
      const calculation = escapeHtml(calculationLabels[calc] || calc || '') + (metric.percentage_scale === 'absolute' ? '<br/><span style="color:#777;">Fixed 0–100%</span>' : '')
      const value = hasData
        ? escapeHtml(formatHeatmapMetric(metric, configuredMetric, fields))
        : '<span style="color:#D32F2F;font-weight:600;">Not populated</span>'
      const absolute = metric.percentage_scale === 'absolute'
      const percent = !absolute && hasData && Number.isFinite(Number(metric.percent))
        ? `${Math.round(Number(metric.percent))}%`
        : ''

      return [
        '<div style="display:grid;grid-template-columns:minmax(90px,1.5fr) minmax(65px,1fr) minmax(65px,1fr) 42px;gap:8px;align-items:center;padding:7px 10px;border-top:1px solid #ECECEC;font:12px Lato,Arial,sans-serif;color:#4B4B4B;">',
        `<div style="font-weight:600;overflow-wrap:anywhere;">${label}</div>`,
        `<div>${calculation}</div>`,
        `<div style="overflow-wrap:anywhere;unicode-bidi:plaintext;">${value}</div>`,
        `<div style="text-align:right;color:#777;">${percent}</div>`,
        '</div>'
      ].join('')
    }).join('')

    return [
      `<div id="infoWindow_${idx}" style="width:340px;max-width:100%;overflow:hidden;border-radius:6px;background:white;">`,
      '<div style="padding:10px 12px;background:#F1F1F1;color:#333;font-family:Lato,Arial,sans-serif;">',
      `<div style="font-size:14px;font-weight:700;overflow-wrap:anywhere;">${escapeHtml(title)}</div>`,
      `<div style="margin-top:3px;font-size:12px;color:#666;">${escapeHtml(context)}</div>`,
      '</div>',
      warning,
      '<div style="display:grid;grid-template-columns:minmax(90px,1.5fr) minmax(65px,1fr) minmax(65px,1fr) 42px;gap:8px;padding:9px 10px 6px;color:#777;font:700 10px Lato,Arial,sans-serif;text-transform:uppercase;letter-spacing:.03em;">',
      '<div>Field</div><div>Calculation</div><div>Value</div><div style="text-align:right;">Share</div>',
      '</div>',
      rows || '<div style="padding:8px 10px;color:#777;font:12px Lato,Arial,sans-serif;">No metrics configured.</div>',
      '</div>'
    ].join('')
  }

  return {
    getMarkerConfig,
    markerIcon,
    statusMarkerIcon,
    getInfoWindowDiv: getHeatmapInfoWindowDiv
  }
}
